import {ContactCompanyDetailsView} from "../../../views/adminArea/matchesPanelViews/CompanyContactDetailsView";

export const CompanyContactDetails = (props) => {

    return (
        <ContactCompanyDetailsView company={props.company}/>
    )
}